import { ShieldAlert, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function SemPermissao() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-cinza-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-red-100 rounded-full p-4">
              <ShieldAlert className="w-16 h-16 text-red-600" />
            </div>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-800 mb-3">
            Acesso Negado
          </h1>
          
          <p className="text-gray-600 mb-6 text-lg">
            Você não tem permissão para acessar este conteúdo.
          </p>
          
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-amber-800">
              Se você acredita que deveria ter acesso a esta página, entre em contato com o administrador do sistema para solicitar as permissões necessárias.
            </p>
          </div>
          
          <button
            onClick={() => navigate("/home")}
            className="w-full bg-azul-400 hover:bg-azul-500 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
          >
            <Home className="w-5 h-5" />
            Voltar para o Início
          </button>
        </div>
      </div>
    </div>
  );
}
